import React from 'react'
import ui from "../../assets/ourservices/uiux.jpg";
import digi from "../../assets/ourservices/digi.jpg";
import cloud from "../../assets/ourservices/cld.jpg";
import ecom from "../../assets/ourservices/ecom.jpg";
import app from "../../assets/ourservices/app.jpg";
import other from "../../assets/ourservices/other.jpg";

const OurService = () => {
    return (
        <div >
            <section className="bg-gray-100 pb-10  dark:bg-dark w-full lg:pb-20 lg:pt-[40px] ">
                <div className="mb-10 md:mb-16">
                    <h2 className="mb-4 text-center text-3xl font-mfont font-bold text-gray-800 md:mb-6 lg:text-3xl">Our Services</h2>
                    <p className=" text-2xl font-medium font-mfont m-4 text-center text-gray-900 md:text-4xl">Services we are best at</p>
                </div>
                <div className="container">
                    <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 m-10">
                        <SingleCard
                            image={app}
                            CardTitle="APPLICATION DEVELOPMENT"
                            titleHref="/makingminds/products"
                            CardDescription="We provide a wide range of software development services, including web and mobile applications. This covers design, development, prototyping, and migration in order to provide a smooth end-to-end solution."
                            Button="View Details"
                        />
                        <SingleCard
                            image={cloud}
                            titleHref="/makingminds/products"
                            CardTitle="CLOUD CONSULTING"
                            CardDescription="Our expertise lies in developing and offering cutting-edge cloud migration and computing solutions that can catapult your company into previously unheard-of levels of success."
                            Button="View Details"
                        />
                        <SingleCard
                            image={ui}
                            titleHref="/makingminds/products"
                            CardTitle="UI/UX DESIGN"
                            CardDescription="Working directly with our customers, as a full-service UX agency, we define, design, and execute revolutionary user experiences that span all platforms and contact points for brands."
                            Button="View Details"
                        />
                        <SingleCard
                            image={digi}
                            CardTitle="DIGITAL MARKETING"
                            titleHref="/makingminds/products"
                            CardDescription=" Digital marketing allows businesses to connect with their customers in a more personalized and measurable way, enabling them to optimize their strategies based on real-time data and insights."
                            Button="View Details"
                        />
                        <SingleCard
                            image={ecom}
                            titleHref="/makingminds/products"
                            CardTitle="E-COMMERCE SOLUTIONS"
                            CardDescription=" E-commerce solutions encompass everything from website development and design to payment processing, inventory management, and order fulfillment."
                            Button="View Details"
                        />
                        <SingleCard
                            image={other}
                            titleHref="/makingminds/products"
                            CardTitle="OTHER SERVICES"
                            CardDescription="Additionally, we provide specialized services that are necessary for the whole app development process."
                            Button="View Details"
                        />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default OurService

const SingleCard = ({
    image,
    Button,
    CardDescription,
    CardTitle,
    titleHref,
    btnHref,
}) => {
    return (
        <>
            <div className="mb-10 overflow-hidden rounded-lg bg-mwhite shadow-1 duration-300 hover:shadow-3 dark:bg-dark-2 dark:shadow-card dark:hover:shadow-3">
                <img src={image} alt="" className="w-full" />
                <div className="p-8 text-center sm:p-9 md:p-7 xl:p-9">
                    <h3>
                        <a
                            href={titleHref ? titleHref : "/"}
                            // target='_blank'
                            // rel="noreferrer"
                            className="mb-4 block font-mfont font-bold text-xl  text-dark hover:text-primary dark:text-white sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]"
                        >
                            {CardTitle}
                        </a>
                    </h3>
                    <p className="mb-7 text-base font-semibold font-mfont leading-relaxed text-body-color dark:text-dark-6">
                        {CardDescription}
                    </p>

                    {/* {Button && (
                        <a
                            href={btnHref ? btnHref : "#"}
                            className="inline-block rounded-full border border-gray-3 px-7 py-2 text-base font-medium text-body-color transition hover:border-mcolor hover:bg-primary hover:text-mcolor dark:border-dark-3 dark:text-dark-6"
                        >
                            {Button}
                        </a>
                    )} */}
                </div>
            </div>
            {/*  */}
        </>
    );
};